
import Vue from 'vue'
import { DataSet } from '@/services/DataSet'

export default Vue.extend({
   name: 'PagerComponent',
   props: {
      data: Object as () => DataSet,
   },
   computed: {
      showPager(): boolean {
         return this.data.hasNextPage || this.data.hasPreviousPage
      },

      isFirstPage(): boolean {
         return this.data.currentPageNumber === 1
      },

      isLastPage(): boolean {
         return this.data.currentPageNumber === this.data.lastPageNumber
      },

      pages(): number[] {
         const pagesEitherSide = 2
         const pageCount = this.data.lastPageNumber

         let pageFrom = Math.max(1, this.data.currentPageNumber - pagesEitherSide)
         let pageTo = Math.min(pageCount, this.data.currentPageNumber + pagesEitherSide)
         pageFrom = Math.max(1, Math.min(pageTo - 2 * pagesEitherSide, pageFrom))
         pageTo = Math.min(pageCount, Math.max(pageFrom + 2 * pagesEitherSide, pageTo))

         const pageNumbers = Array(pageTo - pageFrom + 1)
            .fill(1)
            .map((item, index) => index + pageFrom)

         return pageNumbers
      },
   },
   methods: {
      showPage(pageNumber: number) {
         this.data.showPage(pageNumber)
         this.notifyPageChanged()
      },
      showPreviousPage() {
         this.data.previousPage()
         this.notifyPageChanged()
      },
      showNextPage() {
         this.data.nextPage()
         this.notifyPageChanged()
      },
      showLastPage() {
         this.data.showPage(this.data.lastPageNumber)
         this.notifyPageChanged()
      },
      notifyPageChanged() {
         this.$emit('change', this.data.currentPageNumber)
      },
   },
})
